import apiClient from './Api';
const PREFIX = '/stats';

const getActiveStats = postData => {
  return apiClient({
    url: `${PREFIX}/activestats`,
    method: 'POST',
    data: postData
  });
};

const getMainStats = postData => {
  return apiClient({
    url: `${PREFIX}/mainstats`,
    method: 'POST',
    data: postData
  });
};

const StatsService = {
  getActiveStats,
  getMainStats
};

export default StatsService;
